import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth';
import api from '../api';
import './estilodashuser.css';

export default function ResetSenhaUser() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleResetSenha = async () => {
    if (!novaSenha || !confirmarSenha) {
      setErro(t('dashboard.password.required'));
      setMensagem('');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setErro(t('dashboard.password.mismatch'));
      setMensagem('');
      return;
    }

    if (novaSenha.length < 6) {
      setErro(t('dashboard.password.length'));
      setMensagem('');
      return;
    }

    try {
      setSalvando(true);
      const response = await api.put(
        `/api/clientes/reset-senha/${user.id}`,
        { novaSenha }
      );

      setMensagem(i18n.resolvedLanguage === 'en' ? t('dashboard.password.success') : response.data.message || t('dashboard.password.success'));
      setErro('');
      setNovaSenha('');
      setConfirmarSenha('');
    } catch (error) {
      console.error('Erro ao resetar a senha:', error);

      const status = error.response?.status;
      if (status === 403) {
        setErro(
          t('dashboard.password.forbidden')
        );
      } else {
        setErro(
          i18n.resolvedLanguage === 'en'
            ? t('dashboard.password.error')
            : error.response?.data?.message || t('dashboard.password.error')
        );
      }

      setMensagem('');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="content-page">
      <div className="content-card content-card-small">
        <div className="content-page-header">
          <div>
            <h2>{t('dashboard.password.title')}</h2>
            <p>{t('dashboard.password.intro')}</p>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginBottom: 14 }}>
          <strong>{t('dashboard.password.recommendationTitle')}</strong> {t('dashboard.password.recommendation')}
        </div>

        <div className="reset-senha-form">
          <label htmlFor="novaSenha">{t('dashboard.password.new')}</label>
          <input
            type="password"
            id="novaSenha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            placeholder={t('dashboard.password.newPlaceholder')}
          />

          <label htmlFor="confirmarSenha">{t('dashboard.password.confirm')}</label>
          <input
            type="password"
            id="confirmarSenha"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            placeholder={t('dashboard.password.confirmPlaceholder')}
          />

          <button
            onClick={handleResetSenha}
            className="btn-reset-senha qt-btn qt-btn-primary"
            type="button"
            disabled={salvando}
          >
            {salvando ? t('dashboard.password.changing') : t('dashboard.password.change')}
          </button>
        </div>

        {erro && <p className="error-message">{erro}</p>}
        {mensagem && <p className="success-message">{mensagem}</p>}
      </div>
    </div>
  );
}
